import { ContactInfoColumns } from "./contactInfoColumns";

/**
 * GraphQL selection for the network report (networkStore.ts).
 * Part of the persisted "directory" configuration (key: networkReportColumns);
 * override it to match your datamodel's network table.
 *
 * Defaults target the isidore-acc-v13 model (no also_known relation).
 */
export const initialNetworkReportColumns = [
  "name",
  "id",
  "description",
  "common_network_elements.label",
  "common_network_elements.definition",
  ...ContactInfoColumns,
];

export default initialNetworkReportColumns;
